<template>

<div>

    <h1>Create new agent</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createAgent">

        <AgentFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create agent</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import AgentFields from '@/components/AgentFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'AgentCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      agent: {},
      errors: null
    }
  },
  components: {
    AgentFields,
    Errors
  },
  methods: {
    createAgent () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'agents', {
        method: 'POST',
        body: JSON.stringify(this.agent),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          if(this.$route.path == '/bookings/create') {
            this.$parent.creatingAgent = false
            this.$parent.booking.agent = response.data
          } else {
            this.$router.push({ name: 'agent-edit', params: { id: response.data.id }})
          }
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
